import { ArrowRight, MapPin } from "lucide-react";
import { useEffect, useRef,useState } from "react";
import { Link } from "react-router-dom";
import Reveal from "./ui/reveal";
import Magnetic from "./ui/magnetic";
import Tilt3D from "./ui/tilt3D";
import SplitText from "./ui/splittixt";

const Announcements = () => {
  const announcements = [
    { date: "Dec 2024", title: "Gillco Unveils Meraqui In Style — A premium high-rise lifestyle development for upscale living in Sector 126, Mohali" },
    { date: "Nov 2024", title: "Tricity's Biggest Run For Health Marathon — A health initiative led by Gillco Group" },
    { date: "Oct 2024", title: "Gillco Group Featured in Business Standard — Recognition of our commitment to quality & innovation" },
    { date: "Sep 2024", title: "Gillco Industrial Park crosses 200 acres of operational excellence on IT City Road" },
    { date: "Aug 2024", title: "Forbes India Celebrity 100 — Tejpreet Singh Gill recognized for visionary leadership" },
  ];
  // Duplicate the list for seamless infinite marquee
  const loop = [...announcements, ...announcements];
  return (
    <section className="bg-[#f8f6f2] border-y border-[#C4A265]/20 py-5 lg:py-6 overflow-hidden" data-testid="v13-announcements-section">
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center gap-6 lg:gap-10">
        {/* Label */}
        <div className="flex items-center gap-3 flex-shrink-0 pr-6 lg:pr-10 border-r border-[#C4A265]/30">
          <span className="w-2 h-2 rounded-full bg-[#C4A265] animate-pulse" />
          <span className="text-[10px] lg:text-[11px] tracking-[0.3em] uppercase text-[#C4A265] font-medium whitespace-nowrap">Corporate Announcements</span>
        </div>

        {/* Marquee track */}
        <div className="relative flex-1 overflow-hidden" data-testid="v13-marquee-track">
          {/* Edge fade masks */}
          <div className="pointer-events-none absolute left-0 top-0 bottom-0 w-12 z-10 bg-gradient-to-r from-[#f8f6f2] to-transparent" />
          <div className="pointer-events-none absolute right-0 top-0 bottom-0 w-12 z-10 bg-gradient-to-l from-[#f8f6f2] to-transparent" />

          <div className="v13-marquee flex items-center gap-12 whitespace-nowrap">
            {loop.map((item, i) => (
              <Link
                key={i}
                to={`/spotlight`}
                className="group inline-flex items-center gap-4 text-sm text-[#1a1a1a]/80 hover:text-[#0A4F3B] transition-colors duration-300"
                data-testid={`v13-marquee-item-${i % announcements.length}`}
              >
                <span className="text-[11px] uppercase tracking-[0.2em] text-[#C4A265] font-medium">{item.date}</span>
                <span className="font-light">{item.title}</span>
                <span className="inline-block w-1 h-1 rounded-full bg-[#C4A265]/50 ml-2" />
              </Link>
            ))}
          </div>
        </div>
      </div>

      <style>{`
        @keyframes v13MarqueeScroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .v13-marquee {
          animation: v13MarqueeScroll 60s linear infinite;
          width: max-content;
        }
        .v13-marquee:hover {
          animation-play-state: paused;
        }
        @media (prefers-reduced-motion: reduce) {
          .v13-marquee { animation: none; }
        }
      `}</style>
    </section>
  );
};

export default Announcements;